module.exports = __webpack_public_path__ + "static/media/video.eb629a5d.webp";